module.exports = __webpack_public_path__ + "static/img/bigevent.19ad753.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/bigevent.png
// module id = KO+d
// module chunks = 1